var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSupport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M4.391 13.324h.848V8.237h-.848a2.54 2.54 0 0 0-2.543 2.544 2.54 2.54 0 0 0 2.543 2.543M17.956 13.324h-.848V8.237h.848a2.54 2.54 0 0 1 2.544 2.544 2.54 2.54 0 0 1-2.544 2.543"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M5.24 8.237V6.542c0-2.807 3.128-5.087 5.934-5.087s5.935 2.28 5.935 5.087v1.695M17.109 13.324c0 1.865-1.696 3.391-3.392 3.391M18.202 17.123q.458.33.84.712c.924.907 1.458 1.975 1.458 3.12M1 20.955c0-2.501 2.535-4.638 6.121-5.503"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.87 17.563h-1.696a.85.85 0 0 1-.848-.848.85.85 0 0 1 .848-.847h1.696a.85.85 0 0 1 .848.847.85.85 0 0 1-.848.848"
})));
export default SvgSupport;